import {
  Discount,
  PaymentTermOption,
  Premium,
  TermAddOn,
  TermProduct,
  TermProductDetails,
  TermQuotePlanDetails
} from '@store/termquote';
import {
  MedicalTestAppointments,
  NRIMedicalsInIndia,
  TermBillDeskPaymentData
} from '@views/term/status/types';

export enum TermPolicyStatus {
  PRODUCT_FINALISED = 'Product Finalised',
  KYC_DONE = 'KYC_DONE',
  FORM_WIP = 'Proposal Form WIP',
  FORM_SUBMITTED = 'Proposal Form Submitted',
  DOCUMENTS_VERIFIED = 'Documents Verified',
  MEDICALS_INITIATED = 'Medicals Initiated',
  PAYMENT_DONE = 'Payment Done', // Payment is successful
  PAYMENT_FAILED = 'Payment Failed', // Payment failed
  PAYMENT_ON_HOLD = 'Payment on Hold', // Payment on Hold
  PAYMENT_SUBMITTED = 'Payment Submitted', // Successful payment details are sent to the insurer
  PAYMENT_SUBMISSION_FAILED = 'Payment Submission Failed', // Failed to submit payment details to the insurer
  MEDICALS_SCHEDULED = 'Medicals Scheduled', // Medicals are scheduled, once the medicals are done next will be policy issuance.
  FINAL_PUSH_SUBMITTED = 'FinalPush Submitted', // Final push is submitted to the insurer
  FINAL_PUSH_FAILED = 'FinalPush Failed', // Failed to submit the proposal.
  ISSUED = 'Policy Issued',
  REJECTED = 'Policy Rejected',
  POSTPONED = 'Policy Postponed',
  CANCELLED = 'Policy Cancelled'
}

export enum TermStepStatus {
  ACTIVE = 'active',
  PENDING = 'pending',
  COMPLETED = 'completed',
  INACTIVE = 'inactive'
}

export type Step = {
  pageHeading: string;
  pageCaption: string;
  title: string;
  subTitle: string;
  minToComplete: number;
  btnLabel: string;
  btnLink: string;
  isPaymentStep?: boolean;
  step: string;
  status: TermStepStatus;
  isBDPaymentEnabled?: boolean;
  bdPaymentData?: TermBillDeskPaymentData;
  preCTABtn?: {
    link: string;
    label: string;
  };
};

type MobileNumber = {
  country_code: string;
  mobile: string;
};

export type TermPremiumData = Premium & {
  paymentTerm: number;
  paymentType: string;
  paymentTypeName?: string;
};

export type TermPolicyStatusResponse = {
  data: {
    app_id: string;
    product: string;
    policy_id: string;
    product_details: TermQuotePlanDetails;
    proposal_form: Record<string, any>;
    app_no: string;
    premium_data: TermPremiumData;
    status: TermPolicyStatus;
    requirements_done: boolean;
    url: string | null;
    appointments: MedicalTestAppointments;
    userMobile: string;
    url_error?: string | null;
    policy_no?: string;
    nri_medicals_in_india?: NRIMedicalsInIndia;
    addons: TermAddOn[];
    steps: Step[];
    boundaries: TermProductDetails;
    verified_mobile: MobileNumber;
    is_expired?: boolean;
    expiry_reason?: string | null;
    expiring_message?: string;
    is_nri: boolean;
    nri_country?: string | null;
    payment_option?: PaymentTermOption;
  };
  success: boolean;
};

export type TermStatusBoundary = {
  product: TermProduct;
  boundaries?: {
    discounts?: Discount[] | undefined;
  };
};
